import React from 'react'
import { Card } from 'reactstrap'
import Rejection from '../../assets/images/rejection'
import { useSearchParams } from 'react-router-dom'

const OrderRejection = () => {
  const [searchParams] = useSearchParams()

  const orderId = searchParams.get('orderId')
  return (
    <div className='min-vh-100 d-flex justify-content-center align-items-center'>
      <Card className='w-100 m-3' style={{ maxWidth: '1300px' }}>
        <main className='text-center p-4'>
          <Rejection />
          <section>
            <h1 className='h4 mb-3 mt-4'>Rejection</h1>
            <p className='lead'>You have rejected Pharmacy Order #{orderId}</p>
          </section>
        </main>
      </Card>
    </div>
  )
}

export default OrderRejection
